var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStartFigure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 20,
    viewBox: "0 0 98 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 20,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_16_111",
    transform: "scale(0.0102041 0.05)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_16_111",
    width: 98,
    height: 20,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGIAAAAUCAYAAAB23ujSAAABhUlEQVRYCe2Yz03DMBTGc2CAjsCBAXpD2O/gG/ETQ3SASowAB+4wAhvAkRtsUDYoUls7cEk3KHpOI1UqNnXzevKrZCVNnM/277Of/1SV/NgILFGNG6sfvYV3j7Ch5FDP6X+DcOtrc85WmAjtEyDADuGlhx+7NgjtN6q7fQV5MphAGAUIbQz+X88bhFlrzGhw4SLQETjGhN4YMYOpF1GPDvF/Oxf0gHOuDtUTU3XKlVkh3OdAj+WlUVUuRYaWO4SvGNys51Y/M1SnTAnqxVmwE+GLVlKBIg0xSXkMnFVvXEaQzsaYs4pTsBwtHTZrXO2dm/FIjEiEjTjoExghYSkvLBEvV6vXuEnd0UbO+zJnWoZW05FGDuhUXlp9MVSpXAmH8JkCfOg72dQN7EMe1eRQ2PF8ei1nTgONoM89qo845P/nCppvGKohEt1505E7bNlR83agrRl584WYwGvCrhqFGY96nQpV4XzqBszud3J/IgI/9SWsrJ7SaigkCw9LVJPF9dVFqshfCbyqZ2mJlaAAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartFigure);
export default __webpack_public_path__ + "static/media/startFigure.20455d9da83eb026aecfbf802ce13de3.svg";
export { ForwardRef as ReactComponent };